module.exports = __webpack_public_path__ + "static/media/package_dev_web_plain.d8419766.svg";